export default __webpack_public_path__ + "static/media/eco_img_01.0cc3793b.png";